<template>
  <notification-card
    icon="language"
    icon-class="has-text-danger"
    :iso-timestamp="n['@timestamp']">
    <template #title>
      Keyword: <span class="has-text-danger">{{category}}</span>
    </template>
    <template #menu>
      <NotificationMenu :n="n" variant="danger" />
    </template>
    <template v-if="attCount > 0" #attachments_menu>
      <AttachmentsMenu :n="n" />
    </template>
    <template v-if="attCount > 0" #attachments>
      <AttachmentsViewer :n="n" />
    </template>
    <b-tag v-if="meta['package-name']" class="mb-2" size="is-medium" type="is-danger">{{ meta['package-name'] }}</b-tag>
    <div class="block">
      <p v-if="showKeywordsUnCensored">
        &ldquo;<span v-for="(s, i) in tokenedUncensored" :key="i" :class="s.match != null ? 'is-keyword-match' : ''"
          >{{ s.letters.join('') }}</span>&rdquo;
      </p>
      <p v-else>&ldquo;{{ censored }}&rdquo;</p>
    </div>
    <vuex-input module="userSettings" state="showKeywordsUnCensored" #default="v">
      <b-field>
        <b-switch type="is-danger" :value="v.value" @input="v.commit">show uncensored</b-switch>
      </b-field>
    </vuex-input>
  </notification-card>
</template>

<script>
import { pascalToHuman } from '@/services/text/humanify'
import attachments from '@/services/attachments'
import { mapState } from 'vuex'

export default {
  props: {
    n: Object
  },
  computed: {
    ...mapState('userSettings', ['showKeywordsUnCensored']),
    meta () { return this.n.metaData },
    category () { return pascalToHuman(this.meta['keyword-list'].replace(/^keyword:/, '')) },
    attCount () { return attachments.parse(this.n).all.length },
    matches () { return JSON.parse(this.meta['keyword-matches']) },
    uncensored () { return this.meta.context },
    utfCharacterArr () { return [ ...this.uncensored ] },
    tokenedUncensored () {
      let sections = []
      for (let i=0; i<this.utfCharacterArr.length; i++) {
        if (i === 0) {
          sections.push({ letters: [] })
        }
        // start a section with a match
        const matchStartingHere = this.matches.filter(m => m.offset === i)
        if (matchStartingHere.length > 0) {
          // note: doesn't support match overlapping
          sections.push({ match: matchStartingHere[0], letters: [] })
        }
        // end last section and add a new one
        const lastMatch = sections[sections.length-1].match
        if (lastMatch != null && i == (lastMatch.offset + [ ...lastMatch.text].length)) {
          sections.push({ letters: [] })
        }
        sections[sections.length-1].letters.push(this.utfCharacterArr[i])
      }
      return sections
    },
    censored () {
      let currentInput = this.utfCharacterArr
      for (let match = 0; match < this.matches.length; match++) {
        const m = this.matches[match]
        const lengthOfMatch = [ ...m.text ].length
        const startAt = m.offset
        let result = []
        if (lengthOfMatch === 1) {
          const endAt = startAt + lengthOfMatch
          for (let i=0; i<currentInput.length; i++) {
            if (i >= startAt && i < endAt) {
              result.push('*')
            } else {
              result.push(currentInput[i])
            }
          }
        } else {
          const endAt = startAt + lengthOfMatch - 1
          for (let i=0; i<currentInput.length; i++) {
            if (i === startAt) {
              result.push(currentInput[i])
            } else if (i == endAt) {
              result.push(currentInput[i])
            } else if (i > startAt && i < endAt) {
              result.push('*')
            } else {
              result.push(currentInput[i])
            }
          }
        }
        currentInput = [ ...result.join('') ]
      }
      return currentInput.join('')
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/Colours.scss";
.is-keyword-match {
  color: $danger;
}
</style>